import React, { useState } from 'react';
import {
  about,
  about1,
  about2,
  about3,
  blogs1,
  blogs2,
  blogs3,
  blogs4,
  blogs5,
  blogs6,
  blogs7,
  care1, 
  care10,
  care11,
  care2,
  care3,
  care4,
  care5,
  care6,
  care7,
  care8,
  care9,
  flag1,
  flag2,
  flag3,
  flag4,
  flag5,
  flag6,
  logoAbout,
  opportunity1,
  opportunity2,
  opportunity3,
  opportunity4,
  partners1,
  partners2,
  partners3,
  partners4,
  partners5,
  product1,
  product2,
  product3,
  product4,
  sertifikat1,
  sertifikat2,
  sertifikat3,
  sertifikat4,
  sertifikat5,
  sertifikat6,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  why1,
  why2,
  why3,
  why4,
  why5,
  why6,
  why7,
  why8,
  why9
} from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const blogs = [
  { id: 7, image: blogs7,  title: "Fatima Nuriyeva: Redefining Healthcare Accessibility Across Borders", description: "Bu böyük uğur, səhiyyənin daha əlçatan və keyfiyyətli olması üçün verdiyimiz əmək və səyin təsdiqidir. Fatima xanımın liderliyi altında, innovasiya və əlçatanlıq sahəsindəki məqsədlərimizə doğru addımlamağa davam edirik.Bu, yalnız bir titul deyil, həm də şirkətimizin vizyonunun və məqsədlərinin uğurlu nəticəsidir. Fatima xanımın liderliyi ilə irəliləyəcəyik və daha çox uğura imza atacağıq ! 🌟"},
  { id: 1, image: blogs1,  title: "Plastik Cərrahiyyə: Gözəllik və Özünə Güvən İstəyənlər üçün", description: "Plastik cərrahiyə, yalnız estetik məqsədli deyil, həm də funksional düzəlişləri ehtiva edir. Burun estetikası, üz gərmə, gözaltı cərrahiyyə və liposaksiya kimi prosedurlar, yalnız fiziki görünüşünüzü dəyişdirmək deyil, eyni zamanda özünə inamınızı artırmaq məqsədini daşıyır." },
  { id: 2, image: blogs2,  title: "Saç Əkimi: Yeni Başlangıcın İlk Addımı", description: "Saç əkimi, son illərdə estetik cərrahiyyənin ən çox tələb olunan prosedurlarından biri halına gəlib. Saç tökülməsi, kişilər və qadınlar üçün özünə inam itkisinə səbəb ola bilər. Bu problemlə qarşılaşanlar, saç əkimi ilə təbii və qalıcı nəticələr əldə edərək yenidən gənc və canlı bir görünüşə sahib olurlar. Saç əkimi proseduru, müasir texnologiyalar və təcrübəli həkimlər tərəfindən həyata keçirildikdə, "},
  { id: 3, image: blogs3,  title: "Kardioloji Cərrahiyyə: Ürək Sağlığınızın Qorunması", description: "Ürək xəstəlikləri, dünya üzrə ən çox ölüm səbəbi olan sağlamlıq problemlərindən biridir. Kardioloji cərrahiyyə, ürək xəstəlikləri ilə bağlı ən müasir müalicə üsullarını təqdim edir. Bypass əməliyyatları, Koronaroangioplastika və Qapalı ürək əməliyyatları kimi prosedurlar, ürəyin normal funksiyalarını bərpa etmək üçün istifadə edilir. Müasir texnologiyalarla həyata keçirilən bu əməliyyatlar, xəstələrin həyat "},
  { id: 4, image: blogs4,  title: "Onkoloji Cərrahiyyə: Onkoloji xəstəlik həyatın sonu deyil", description: "Xərçəng, dünyada hər il milyonlarla insanın həyatını təsir edən ciddi bir xəstəlikdir. Onkoloji cərrahiyə, xərçəngin müalicəsində ən vacib sahələrdən biridir. Şiş əməliyyatları, Kimyaterapiya öncəsi və sonrakı əməliyyatlar və Dəri xərçəngi müalicəsi kimi prosedurlar, xərçəngin erkən mərhələlərində müalicə edilməsi və təkrarlanmasının qarşısını "},
  { id: 5, image: blogs5,  title: "Oftalmoloji Cərrahiyyə: Görmə Sağlığınızı Qoruyun", description: "Göz sağlamlığı, ümumi sağlamlığın vacib bir hissəsidir. Oftalmoloji cərrahiyyə, görmə problemlərini həll etmək və gözlə bağlı xəstəlikləri müalicə etmək üçün həyata keçirilir. Katarakt əməliyyatları, Refraktiv cərrahiyyə və Göz ətrafı plastik əməliyyatlar kimi prosedurlar, görmə qabiliyyətini bərpa edərək, insanların gündəlik həyatlarında daha yaxşı nəticələr əldə etmələrinə kömək edir. "},
  { id: 6, image: blogs6,  title: "Stomatoloji Cərrahiyyə: Sağlam Gülüşün Təsiri", description: "Göz sağlamlığı, ümumi sağlamlığın vacib bir hissəsidir. Oftalmoloji cərrahiyyə, görmə problemlərini həll etmək və gözlə bağlı xəstəlikləri müalicə etmək üçün həyata keçirilir. Katarakt əməliyyatları, Refraktiv cərrahiyyə və Göz ətrafı plastik əməliyyatlar kimi prosedurlar, görmə qabiliyyətini bərpa edərək, insanların gündəlik həyatlarında daha yaxşı nəticələr əldə etmələrinə kömək edir. "},
];
 
const Blogs = () => {
  const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [showText, setShowText] = useState(false);
    const [showButton, setShowButton] = useState(false);
      const flags = [flag1, flag2, flag3, flag4, flag5, flag6];
      const partners = [partners1, partners2, partners3, partners4, partners5];


  return (

     <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px]">
          <p >{t("Ana səhifə")} <i className={`fas fa-chevron-right text-[black] ml-3 mr-3`}/> {t("Bloq")}</p>
          <div>
          <div className="max-w-container mx-auto mt-[24px] md:mt-[56px] ">
          <div className="grid grid-cols-1 md:grid-cols-3 mt-10 gap-10">
  {blogs.map((item) => (
    <a href={`/blogs/${item.id}`}>
      <div className="relative w-full h-64 bg-gray-200 rounded-[12px] overflow-hidden">
      {/* Background Image */}
      <img
        src={item.image}
        alt="Blog"
        className="w-full h-full object-cover"
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
      
      {/* Blog Tag */}
      <div className="absolute top-4 left-4 bg-black bg-opacity-50 text-white text-sm px-3 py-1 rounded-[21px]">
        {t("Bloq")}
      </div>
      
      {/* Title */}
      <h2 className="absolute bottom-4 left-4 text-white text-xl font-semibold mx-auto">
        {t(item.title)}
      </h2>
    </div>
    </a>
  ))}
</div>

    </div>
          </div>
         
        </div>
  );
};

export default Blogs;